import { useNavigate } from 'react-router-dom';
import { Button, Subtitle1 } from '@fluentui/react-components';
import { AddFilled } from '@fluentui/react-icons';

import { useDocumentTitle, useSearchParams } from '@shared/hooks';

import { ReviewsTable } from '../components/register/ReviewsTable';
import { getReviewRegisterEntries, getReviewSetupPath, getReviewSpace } from '../helpers';
import { ReviewPageScaffold } from '../layouts/ReviewPageScaffold';
import { useReviewStore } from '../state/ReviewStore';

const ReviewsRegisterContent = () => {
  const navigate = useNavigate();
  const { searchParams } = useSearchParams();
  const productId = searchParams.get('productId') ?? undefined;
  const { config, reviews, reviewBases, now } = useReviewStore();

  const visibleReviews = getReviewRegisterEntries(reviews, now, productId, getReviewSpace(config, productId)?.history);

  const handleStart = () => navigate(getReviewSetupPath(productId));

  return (
    <>
      <div className="flex items-center justify-between gap-4">
        <Subtitle1>Review</Subtitle1>
        <Button appearance="primary" icon={<AddFilled />} onClick={handleStart}>
          New review
        </Button>
      </div>

      <ReviewsTable reviews={visibleReviews} bases={reviewBases} productId={productId} onStart={handleStart} />
    </>
  );
};

const ReviewsRegisterPage = () => {
  useDocumentTitle('Review');
  return (
    <ReviewPageScaffold>
      <ReviewsRegisterContent />
    </ReviewPageScaffold>
  );
};

export default ReviewsRegisterPage;
